module.exports = __webpack_public_path__ + "active_user.d54a704e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/active_user.png
// module id = 468
// module chunks = 0